var version = "13.3.0";
var hcPackage = {
	version: version};

export { hcPackage as default, version };
